module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-OMEGA3.b385059b.png";